const EXPAND_DASHBOARD_NAV = 'EXPAND_DASHBOARD_NAV';
const COLLAPSE_DASHBOARD_NAV = 'COLLAPSE_DASHBOARD_NAV';
const TOGGLE_DASHBOARD_NAV = 'TOGGLE_DASHBOARD_NAV';
const DASHBOARD_NAV_MOUNTED = 'DASHBOARD_NAV_MOUNTED';
const DASHBOARD_NAV_UNMOUNTED = 'DASHBOARD_NAV_UNMOUNTED';


/*
	This reducer is for generic app-wide ui state that for some reason can't be managed by react useState
*/


const initialState = {
	isDashboardNavCollapsed: false,
	// How many DashboardLayouts (the pages with the collapsible sidebar) are mounted.
	// The header shows its sidebar toggle only while this is above 0. A count rather
	// than a flag stays right if one layout mounts before the previous one unmounts.
	mountedDashboardNavCount: 0,
};

// Selector: true when the current page has the collapsible dashboard sidebar
export const selectHasDashboardNav = (state) =>
	(state.uiState?.mountedDashboardNavCount || 0) > 0;

export const dashboardNavMounted = () => ({ type: DASHBOARD_NAV_MOUNTED });
export const dashboardNavUnmounted = () => ({ type: DASHBOARD_NAV_UNMOUNTED });


export const toggleCollapseDashboardNav = () => (dispatch, getState) => {
	let state = getState();
	let isCollapsed = state.uiState.isDashboardNavCollapsed;
	return dispatch({
		type: TOGGLE_DASHBOARD_NAV,
		payload: {
			isDashboardNavCollapsed: !isCollapsed,
		}
	});
};

export const expandDashboardNav = () => (dispatch) => {
	return dispatch({
		type: EXPAND_DASHBOARD_NAV,
		payload: {
			isDashboardNavCollapsed: false,
		}
	});
};

export const collapseDashboardNav = () => (dispatch) => {
	return dispatch({
		type: COLLAPSE_DASHBOARD_NAV,
		payload: {
			isDashboardNavCollapsed: true,
		}
	});
};

const uiStateReducer = (state = initialState, action) => {
	switch (action.type) {
		case EXPAND_DASHBOARD_NAV:
		case COLLAPSE_DASHBOARD_NAV:
		case TOGGLE_DASHBOARD_NAV:
			return {
				...state,
				...action.payload,
			};
		case DASHBOARD_NAV_MOUNTED:
			return {
				...state,
				mountedDashboardNavCount: state.mountedDashboardNavCount + 1,
			};
		case DASHBOARD_NAV_UNMOUNTED:
			return {
				...state,
				mountedDashboardNavCount: Math.max(0, state.mountedDashboardNavCount - 1),
			};
		default:
			return state;
	}
};

export default uiStateReducer;
